import AgyleDialog from '../../modal/agyleDialog';
import SingleNoteComponent from '../singleNote';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {clinicalNoteTypeDict} from '../../../store/reducers/dicts';

const HistoryClinicalNotes = ({open, onClose, filterText, historyNotes = []}) => {
    const {t} = useTranslation();

    const clinicalNoteType = useSelector(clinicalNoteTypeDict);

    const isVisible = (note) => {
        if (!filterText) return true;
        if (note?.note) {
            if (note.note.startsWith('data:image/png;base64')) return false;
            return note.note.toLowerCase().includes(filterText.toLowerCase());
        }
        return false;
    };

    return (
        <AgyleDialog
            open={open}
            onClose={onClose}
            width="xl"
            fullWidth
            title={t('Audit history')}
            disableSave
        >
            {historyNotes?.map(
                (note, index) =>
                    isVisible(note) && (
                        <SingleNoteComponent
                            filterText={filterText}
                            index={index}
                            key={note.__id}
                            note={note}
                            clinicalNoteTypes={clinicalNoteType}
                        />
                    ),
            )}
        </AgyleDialog>
    );
};

export default HistoryClinicalNotes;